import { LinkButton, ModalWindow, UIHeading2 } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';

import { selectRatingInfoModalModerationUrl, selectShowRatingInfoModal } from '../../selectors/modals';
import { toggleRatingInfoModal } from '../../actions/modals';
import * as styles from './RatingInformationModal.css';

export const RatingInformationModal = () => {
  const dispatch = useDispatch();
  const show = useSelector(selectShowRatingInfoModal);
  const moderationUrl = useSelector(selectRatingInfoModalModerationUrl);

  const onClose = () => {
    dispatch(toggleRatingInfoModal(false));
  };

  return (
    <ModalWindow open={show} onClose={onClose} portal fixed={false} size="M">
      <div className={styles['root']}>
        <UIHeading2>Рейтинг основан на отзывах пользователей Циана и других похожих сервисов</UIHeading2>
        <div className={styles['link']}>
          <LinkButton theme="fill_white_primary" fullWidth href={moderationUrl} target="_blank" rel="noreferrer">
            Правила модерации
          </LinkButton>
        </div>
      </div>
    </ModalWindow>
  );
};
